import React from "react"
import autobind from "class-autobind"
import { IWorkflow } from "../../models"
import WorkflowDrawer from "./WorkflowDrawer"
import WorkflowStore from "../../stores/WorkflowStore"

interface IProps {
}

interface IState {
    accountSetupWorkflow: IWorkflow
    showWorkflowDrawer: boolean
}

export default class Workflow extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props)
        this.state = {
            accountSetupWorkflow: WorkflowStore.getAccountSetupWorkflow(),
            showWorkflowDrawer: WorkflowStore.getShowWorkflowDrawer()
        }
        autobind(this)
    }

    componentWillMount() {
        this.changeEvent()
    }

    componentDidMount() {
        WorkflowStore.on("change", this.changeEvent)
    }

    componentWillUnmount() {
        WorkflowStore.removeListener("change", this.changeEvent)
    }

    changeEvent() {
        this.setState({
            accountSetupWorkflow: WorkflowStore.getAccountSetupWorkflow(),
            showWorkflowDrawer: WorkflowStore.getShowWorkflowDrawer()
        })
    }

    render() {
        return (
            <span>
                {this.state.showWorkflowDrawer &&
                    <WorkflowDrawer workflowId={this.state.accountSetupWorkflow.Id} handleClose={() => WorkflowStore.setShowWorkflowDrawer(false)} />
                }
            </span>
        )
    }
}